import { ChevronRight } from 'lucide-react';
import { Fragment } from 'react';
import { Link } from 'react-router';

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="row nowrap small"
      style={{ gap: 8, color: 'var(--color-muted)', minWidth: 0 }}
    >
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <Fragment key={i}>
            {i > 0 && <ChevronRight size={14} color="var(--color-muted-soft)" aria-hidden />}
            {c.to && !last ? (
              <Link to={c.to} style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                {c.label}
              </Link>
            ) : (
              <span
                aria-current={last ? 'page' : undefined}
                style={{
                  color: last ? 'var(--color-body)' : undefined,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 320,
                }}
              >
                {c.label}
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
